(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[50],{

/***/ "./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Faccount%2F%5Bprofile%5D.tsx&page=%2Faccount%2F%5Bprofile%5D!":
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/[profile]",
      function () {
        return __webpack_require__("./src/pages/account/[profile].tsx");
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ "./src/components/Elements/EditorRank/EditorRank.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var react_icons_ri__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./node_modules/react-icons/ri/index.esm.js");




const RankIcon = (param)=>{
    let { rank , size  } = param;
    switch(rank){
        case 0:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Center */ .M5, {
                color: "#DD6B20",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ri__WEBPACK_IMPORTED_MODULE_3__/* .RiTrophyFill */ .e6w, {
                    fontSize: size
                })
            });
        case 1:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Center */ .M5, {
                color: "#D69E2E",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ri__WEBPACK_IMPORTED_MODULE_3__/* .RiTrophyFill */ .e6w, {
                    fontSize: size
                })
            });
        case 2:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Center */ .M5, {
                color: "thirdRankColor",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ri__WEBPACK_IMPORTED_MODULE_3__/* .RiTrophyFill */ .e6w, {
                    fontSize: size
                })
            });
        case -1:
            return null;
        default:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Center */ .M5, {
                color: "brandLinkColor",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ri__WEBPACK_IMPORTED_MODULE_3__/* .RiStarFill */ .Kz, {
                    fontSize: size
                })
            });
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (RankIcon);


/***/ }),

/***/ "./src/components/Icons/lensterIcon.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/@chakra-ui/icon/dist/index.esm.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");



const LensterIcon = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO, {
        viewBox: "0 0 24 24",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M6.85241 7.07652C7.5559 8.15949 8.36078 9.48293 8.99204 10.5397C9.18104 10.8561 9.35413 11.148 9.50383 11.4016C8.93261 11.4371 8.19446 11.4677 7.41909 11.4592C6.57518 11.4501 5.70837 11.3949 4.97213 11.2573C4.20296 11.1136 3.708 10.9025 3.48015 10.6798C2.8997 10.1127 2.5968 9.16031 2.63842 8.1C2.67987 7.04388 3.06042 6.01616 3.67382 5.36176C3.87961 5.14222 4.08806 5.08947 4.34234 5.12678C4.63755 5.1701 4.99483 5.34191 5.37871 5.618C5.7533 5.88741 6.1025 6.21909 6.37563 6.51105C6.51099 6.65574 6.62424 6.78699 6.70896 6.89053C6.75131 6.94231 6.78557 6.98597 6.81121 7.01987C6.82401 7.03679 6.83406 7.05047 6.8415 7.06087C6.84881 7.07109 6.85209 7.07604 6.85239 7.07649L6.85241 7.07652Z",
                stroke: "#718096",
                strokeWidth: "1.4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                id: "path-2-inside-1_18627_135",
                fill: "white",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M14.152 5.47177C13.1432 7.88763 11.5735 11.1666 11.5735 11.1666C11.5735 11.1666 7.64861 6.30819 8.03205 4.17218C8.41549 2.03616 11.1526 0.443792 13.2952 0.84473C15.4378 1.24567 14.3201 5.06912 14.152 5.47177Z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M14.152 5.47177L12.8617 4.92284L14.152 5.47177ZM11.5735 11.1666L10.4895 12.0444L11.8828 13.7691L12.8348 11.7803L11.5735 11.1666ZM12.8617 4.92284C12.3675 6.10638 11.7316 7.51134 11.2152 8.62851C10.9578 9.18532 10.7317 9.66725 10.57 10.0098C10.4892 10.181 10.4245 10.3173 10.3802 10.4105C10.358 10.4572 10.3409 10.493 10.3294 10.5171C10.3237 10.5292 10.3193 10.5383 10.3164 10.5443C10.315 10.5473 10.3139 10.5495 10.3132 10.551C10.3129 10.5517 10.3126 10.5523 10.3124 10.5526C10.3124 10.5528 10.3123 10.5529 10.3123 10.553C10.3123 10.553 10.3122 10.553 10.3122 10.553C10.3122 10.553 10.3122 10.553 11.5735 11.1666C12.8348 11.7803 12.8348 11.7802 12.8349 11.7802C12.8349 11.7801 12.8349 11.7801 12.8349 11.78C12.835 11.7799 12.8351 11.7797 12.8352 11.7795C12.8354 11.779 12.8357 11.7784 12.8361 11.7775C12.837 11.7758 12.8382 11.7733 12.8397 11.77C12.8428 11.7635 12.8474 11.7539 12.8534 11.7413C12.8654 11.7162 12.883 11.6793 12.9057 11.6315C12.9512 11.536 13.017 11.3972 13.0991 11.2233C13.2633 10.8755 13.4926 10.3867 13.7537 9.8218C14.2744 8.69549 14.9276 7.25301 15.4422 6.0207L12.8617 4.92284ZM11.5735 11.1666C12.6576 10.2889 12.6577 10.289 12.6578 10.2891C12.6578 10.2891 12.6579 10.2892 12.6579 10.2892C12.6579 10.2893 12.6579 10.2892 12.6578 10.2891C12.6577 10.2889 12.6573 10.2884 12.6566 10.2876C12.6554 10.2861 12.6532 10.2833 12.6501 10.2795C12.644 10.2719 12.6343 10.2597 12.6213 10.2434C12.5954 10.2107 12.5562 10.1611 12.5059 10.0964C12.4053 9.96701 12.2603 9.77784 12.0868 9.54355C11.7385 9.07315 11.2817 8.42948 10.8397 7.72771C10.3933 7.01915 9.98476 6.28701 9.71377 5.63476C9.41769 4.92213 9.38805 4.54177 9.40817 4.42969L6.65594 3.91467C6.48434 4.87059 6.80153 5.89854 7.13353 6.69763C7.49061 7.55709 7.99137 8.44007 8.47833 9.21312C8.96957 9.99297 9.47003 10.6974 9.84567 11.2047C10.0342 11.4593 10.1928 11.6664 10.3053 11.811C10.3616 11.8834 10.4064 11.9402 10.4378 11.9797C10.4535 11.9995 10.4658 12.0149 10.4745 12.0258C10.4788 12.0312 10.4823 12.0355 10.4848 12.0386C10.486 12.0402 10.487 12.0414 10.4878 12.0424C10.4882 12.0429 10.4885 12.0433 10.4888 12.0436C10.489 12.0438 10.4891 12.044 10.4892 12.0441C10.4893 12.0443 10.4895 12.0444 11.5735 11.1666ZM9.40817 4.42969C9.50904 3.86773 9.96315 3.23173 10.7409 2.75344C11.5143 2.27783 12.3869 2.09903 13.0478 2.2227L13.5426 -0.533244C12.0609 -0.81051 10.4936 -0.393591 9.26697 0.360752C8.04466 1.11242 6.9385 2.3406 6.65594 3.91467L9.40817 4.42969ZM13.0478 2.2227C13.0805 2.22881 13.0611 2.20233 13.0879 2.26052C13.1497 2.39478 13.206 2.67054 13.1926 3.10459C13.1799 3.51514 13.1092 3.95013 13.0264 4.31742C12.9394 4.70378 12.859 4.92936 12.8617 4.92284L15.4422 6.0207C15.5854 5.67773 15.9492 4.4537 15.9876 3.21062C16.0068 2.58837 15.9513 1.80792 15.6253 1.09994C15.2644 0.315886 14.5812 -0.338879 13.5426 -0.533244L13.0478 2.2227Z",
                fill: "#718096",
                mask: "url(#path-2-inside-1_18627_135)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                id: "path-4-inside-2_18627_135",
                fill: "white",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M18.8885 10.9673C16.3329 11.2655 12.7652 11.4924 12.7652 11.4924C12.7652 11.4924 14.9629 5.60782 16.9713 4.89277C18.9796 4.17772 21.688 5.82053 22.4052 7.92052C23.1225 10.0205 19.3144 10.9176 18.8885 10.9673Z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M18.8885 10.9673L18.742 9.57101L18.8885 10.9673ZM12.7652 11.4924L11.4608 11.0088L10.7056 13.0309L12.8389 12.8952L12.7652 11.4924ZM18.742 9.57101C17.4913 9.71697 15.9817 9.84661 14.7755 9.9402C14.1744 9.98685 13.6524 10.0242 13.281 10.05C13.0953 10.0628 12.9474 10.0728 12.8461 10.0795C12.7955 10.0828 12.7566 10.0854 12.7304 10.0871C12.7173 10.0879 12.7074 10.0885 12.7009 10.089C12.6976 10.0892 12.6952 10.0893 12.6936 10.0894C12.6928 10.0895 12.6922 10.0895 12.6919 10.0895C12.6917 10.0895 12.6915 10.0896 12.6915 10.0896C12.6914 10.0896 12.6914 10.0896 12.6914 10.0896C12.6914 10.0896 12.6914 10.0896 12.7652 11.4924C12.8389 12.8952 12.839 12.8952 12.839 12.8952C12.839 12.8952 12.8391 12.8952 12.8392 12.8952C12.8393 12.8952 12.8395 12.8952 12.8398 12.8952C12.8403 12.8951 12.841 12.8951 12.8419 12.895C12.8438 12.8949 12.8465 12.8947 12.8501 12.8945C12.8572 12.894 12.8676 12.8934 12.8813 12.8925C12.9087 12.8907 12.9489 12.8881 13.0008 12.8846C13.1046 12.8778 13.2554 12.8676 13.4441 12.8546C13.8215 12.8284 14.3512 12.7905 14.9615 12.7431C16.1781 12.6487 17.7301 12.5158 19.035 12.3635L18.742 9.57101ZM12.7652 11.4924C14.0695 11.976 14.0694 11.9761 14.0694 11.9762C14.0694 11.9762 14.0694 11.9763 14.0693 11.9764C14.0693 11.9764 14.0693 11.9764 14.0694 11.9763C14.0695 11.976 14.0697 11.9754 14.0701 11.9744C14.0708 11.9725 14.072 11.9693 14.0738 11.9646C14.0773 11.9554 14.0828 11.9408 14.0903 11.9212C14.1054 11.8819 14.1283 11.8227 14.1585 11.746C14.219 11.5927 14.3085 11.3705 14.4223 11.1007C14.6508 10.5589 14.9732 9.83539 15.3523 9.09635C15.7352 8.34988 16.1563 7.62646 16.5766 7.06529C17.0388 6.44808 17.3395 6.24763 17.4238 6.21763L16.5188 3.56792C15.5989 3.89544 14.8717 4.6987 14.357 5.38596C13.8004 6.12925 13.2955 7.01104 12.8779 7.8251C12.4565 8.64658 12.1039 9.43887 11.8576 10.0228C11.734 10.3159 11.6361 10.559 11.5685 10.7302C11.5347 10.8159 11.5085 10.8838 11.4903 10.9311C11.4813 10.9547 11.4742 10.9733 11.4693 10.9863C11.4668 10.9929 11.4649 10.998 11.4635 11.0018C11.4628 11.0037 11.4622 11.0052 11.4617 11.0064C11.4615 11.007 11.4613 11.0075 11.4612 11.0079C11.4611 11.0081 11.461 11.0083 11.461 11.0084C11.4609 11.0086 11.4608 11.0088 12.7652 11.4924ZM17.4238 6.21763C17.925 6.03917 18.6767 6.11732 19.4736 6.57441C20.2611 7.02616 20.8575 7.72018 21.0863 8.3901L23.7241 7.45093C23.2357 6.02087 22.1193 4.84349 20.8712 4.12761C19.6325 3.41705 18.0259 3.03132 16.5188 3.56792L17.4238 6.21763ZM21.0863 8.3901C21.1072 8.45136 21.1082 8.43436 21.0768 8.47982C20.9977 8.59433 20.7986 8.77503 20.4284 8.9744C20.0779 9.16306 19.6774 9.31355 19.3267 9.42068C18.9566 9.53371 18.7293 9.57249 18.742 9.57101L19.035 12.3635C19.4055 12.3203 20.6365 12.036 21.7228 11.4511C22.2681 11.1575 22.9132 10.7171 23.3596 10.0712C23.8538 9.3563 24.0618 8.43967 23.7241 7.45093L21.0863 8.3901Z",
                fill: "#718096",
                mask: "url(#path-4-inside-2_18627_135)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M17.2756 17.1331C16.4816 16.1175 15.566 14.8715 14.8462 13.8755C14.6302 13.5767 14.4324 13.301 14.2612 13.0615C14.8276 12.9747 15.5618 12.8777 16.3365 12.8164C17.1779 12.7498 18.0461 12.727 18.7912 12.7979C19.5699 12.872 20.0803 13.0379 20.3256 13.2385C20.9515 13.7505 21.3353 14.671 21.3851 15.7313C21.4347 16.7871 21.1442 17.8458 20.5888 18.5536C20.4017 18.792 20.1977 18.8631 19.9416 18.8487C19.6443 18.8321 19.274 18.6932 18.8681 18.4528C18.4721 18.2183 18.0959 17.9194 17.7988 17.6531C17.6516 17.5212 17.5275 17.4007 17.4343 17.3052C17.3876 17.2575 17.3498 17.2171 17.3214 17.1857C17.3072 17.17 17.296 17.1573 17.2877 17.1476C17.2797 17.1383 17.276 17.1337 17.2756 17.1332C17.2756 17.1331 17.2756 17.1331 17.2756 17.1331Z",
                stroke: "#718096",
                strokeWidth: "1.4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M10.5656 19.3732C10.9311 18.1281 11.4128 16.6496 11.8047 15.4782C11.9207 15.1317 12.0285 14.8126 12.1229 14.5352C12.5126 14.9587 13.0013 15.512 13.4847 16.1182C14.0175 16.7863 14.5305 17.5022 14.8982 18.1686C15.2816 18.8634 15.4418 19.391 15.4195 19.719C15.3631 20.546 14.8353 21.3956 14.0117 22.04C13.1901 22.6829 12.1767 23.0387 11.2986 22.9764C11.011 22.9559 10.8401 22.8311 10.7042 22.6053C10.5467 22.3438 10.447 21.9507 10.4092 21.4708C10.3723 21.0026 10.3988 20.5148 10.444 20.1128C10.4664 19.9135 10.4929 19.7402 10.5167 19.607C10.5287 19.5405 10.5397 19.4854 10.5489 19.4433C10.5535 19.4222 10.5574 19.4054 10.5605 19.3927L10.5642 19.378C10.5652 19.3744 10.5656 19.3729 10.5656 19.3732Z",
                stroke: "#718096",
                strokeWidth: "1.4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M4.97656 14.9277C6.20729 14.5972 7.69369 14.2463 8.87697 13.9771C9.23335 13.896 9.56155 13.8225 9.84611 13.7594C9.69459 14.3245 9.48377 15.0522 9.2242 15.8037C8.94349 16.6163 8.61276 17.4361 8.24791 18.1029C7.86637 18.8003 7.51198 19.2082 7.23519 19.355C6.52615 19.7309 5.54795 19.7177 4.57747 19.3352C3.61164 18.9544 2.77948 18.2542 2.36903 17.4472C2.22974 17.1733 2.24959 16.9525 2.36562 16.72C2.50044 16.4498 2.77387 16.1609 3.15279 15.8796C3.5226 15.6051 3.94203 15.375 4.30037 15.2054C4.47793 15.1214 4.63591 15.0544 4.759 15.006C4.82054 14.9818 4.87194 14.9628 4.91148 14.949C4.93123 14.9421 4.94705 14.9369 4.95898 14.9331C4.97135 14.9291 4.97678 14.9277 4.97656 14.9277Z",
                stroke: "#718096",
                strokeWidth: "1.4"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LensterIcon);


/***/ }),

/***/ "./src/components/Profile/CustomTab.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ CustomTab; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/@chakra-ui/tabs/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./node_modules/@chakra-ui/system/dist/index.esm.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");



const CustomTab = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((props, ref)=>{
    const { noTab , p , ...rest } = props;
    const tabProps = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .useTab */ .xD)({
        ...rest,
        ref
    });
    const isSelected = !!tabProps["aria-selected"];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .chakra.button */ .m$.button, {
        display: "flex",
        alignItems: "center",
        _focus: {
            boxShadow: "none"
        },
        p: p || "5",
        cursor: "pointer",
        color: "fadedText2",
        pos: "relative",
        ...isSelected && {
            color: "black",
            _dark: {
                color: "white"
            },
            _after: {
                transition: "background-color 0.4s ease 0s",
                bg: "blue.400",
                bottom: 0,
                left: 0,
                content: "''",
                h: "2px",
                w: "full",
                pos: "absolute",
                borderTopRadius: "base"
            }
        },
        ...props,
        ...!noTab && tabProps,
        children: tabProps.children
    });
});


/***/ }),

/***/ "./src/components/Wiki/WikiPreviewCard/WikiPreviewCard.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ WikiPreviewCard_WikiPreviewCard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("./node_modules/react/jsx-runtime.js");
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("./node_modules/react/index.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
// EXTERNAL MODULE: ./src/components/Elements/Avatar/DisplayAvatar.tsx
var DisplayAvatar = __webpack_require__("./src/components/Elements/Avatar/DisplayAvatar.tsx");
// EXTERNAL MODULE: ./src/hooks/useENSData.ts
var useENSData = __webpack_require__("./src/hooks/useENSData.ts");
// EXTERNAL MODULE: ./src/utils/textUtils.ts
var textUtils = __webpack_require__("./src/utils/textUtils.ts");
// EXTERNAL MODULE: ./src/components/Elements/index.ts + 11 modules
var Elements = __webpack_require__("./src/components/Elements/index.ts");
// EXTERNAL MODULE: ./src/components/Elements/LinkElements/LinkOverlay.tsx
var LinkOverlay = __webpack_require__("./src/components/Elements/LinkElements/LinkOverlay.tsx");
// EXTERNAL MODULE: ./src/utils/DataTransform/getUsername.ts
var getUsername = __webpack_require__("./src/utils/DataTransform/getUsername.ts");
// EXTERNAL MODULE: ./src/utils/WikiUtils/getWikiImageUrl.ts
var getWikiImageUrl = __webpack_require__("./src/utils/WikiUtils/getWikiImageUrl.ts");
// EXTERNAL MODULE: ./src/data/Constants.ts
var Constants = __webpack_require__("./src/data/Constants.ts");
// EXTERNAL MODULE: ./src/components/Elements/Image/Image.tsx
var Image = __webpack_require__("./src/components/Elements/Image/Image.tsx");
;// CONCATENATED MODULE: ./src/data/blurPlaceholder.ts
const blurDataURL = "data:image/webp;base64,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";

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__("./node_modules/react-redux/es/index.js");
// EXTERNAL MODULE: ./src/hooks/useTranslatedTimestamps.ts
var useTranslatedTimestamps = __webpack_require__("./src/hooks/useTranslatedTimestamps.ts");
;// CONCATENATED MODULE: ./src/components/Wiki/WikiPreviewCard/WikiPreviewCard.tsx















const WikiPreviewCard = (param)=>{
    let { wiki , showLatestEditor =false , lastUpdated  } = param;
    var ref, ref1, ref2, ref3, ref4;
    const { updated , title , id  } = wiki;
    const [, userENSDomain] = (0,useENSData/* useENSData */.L)(((ref = wiki.user) === null || ref === void 0 ? void 0 : ref.id) || "");
    const lang = (0,es.useSelector)((state)=>state.app.language);
    var ref5;
    const translatedTimestamp = (0,useTranslatedTimestamps/* useTranslatedTimestamps */.L)("Edited", lang, (ref5 = updated !== null && updated !== void 0 ? updated : lastUpdated) !== null && ref5 !== void 0 ? ref5 : "");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* LinkBox */.fG, {
        w: "100%",
        h: "100%",
        bgColor: "cardBg",
        border: "1px",
        borderColor: "cardBorderColor",
        transition: "all 0.3s",
        _hover: {
            transform: "scale(1.02)"
        },
        rounded: "lg",
        overflow: "hidden",
        cursor: "pointer",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AspectRatio */.oM, {
                w: "100%",
                ratio: Constants/* WIKI_IMAGE_ASPECT_RATIO */.ag,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                    src: (0,getWikiImageUrl/* getWikiImageUrl */.A)(wiki.images),
                    alt: wiki.title,
                    boxSize: "100%",
                    imgBoxSize: Constants/* IMAGE_BOX_SIZE */.xh,
                    placeholder: "blur",
                    blurDataURL: blurDataURL
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
                spacing: 3,
                p: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkOverlay/* default */.Z, {
                        href: "/wiki/".concat(id),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                            fontSize: "xl",
                            fontWeight: "semibold",
                            noOfLines: 1,
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            orientation: "vertical",
                            children: (0,textUtils/* shortenText */.El)(title, 65)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                        h: "95",
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                flex: "1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    fontSize: "md",
                                    opacity: 0.7,
                                    noOfLines: 2,
                                    textOverflow: "ellipsis",
                                    overflow: "hidden",
                                    orientation: "vertical",
                                    children: wiki.summary
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Spacer */.LZ, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                    flexWrap: "wrap",
                                    mt: 2,
                                    justify: "space-between",
                                    children: [
                                        showLatestEditor && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                            fontSize: "sm",
                                            py: 2,
                                            color: "brandLinkColor",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayAvatar/* default */.Z, {
                                                    address: (ref1 = wiki.user) === null || ref1 === void 0 ? void 0 : ref1.id,
                                                    avatarIPFS: (ref2 = wiki.user.profile) === null || ref2 === void 0 ? void 0 : ref2.avatar,
                                                    alt: (ref3 = wiki.user.profile) === null || ref3 === void 0 ? void 0 : ref3.username
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* Link */.rU, {
                                                    href: "/account/".concat((ref4 = wiki.user) === null || ref4 === void 0 ? void 0 : ref4.id),
                                                    children: (0,getUsername/* getUsername */.M)(wiki.user, userENSDomain)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                            py: 2,
                                            m: "0px !important",
                                            color: "gray.400",
                                            fontSize: "sm",
                                            children: translatedTimestamp
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var WikiPreviewCard_WikiPreviewCard = (WikiPreviewCard);


/***/ }),

/***/ "./src/hooks/useInfiniteData.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ useInfiniteData; }
/* harmony export */ });
/* harmony import */ var _data_Constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/data/Constants.ts");
/* harmony import */ var _store_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/store/store.ts");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");



const useInfiniteData = function(opts) {
    let initialData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    const [hasMore, setHasMore] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)( true && initialData.length > 0);
    const [data, setData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initialData);
    const [offset, setOffset] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(opts.defaultLoading || false);
    const updatedOffset = offset + _data_Constants__WEBPACK_IMPORTED_MODULE_2__/* .ITEM_PER_PAGE */ .BJ;
    const fetcher = (noOffset)=>{
        if (loading) return;
        const fetchNewWikis = async ()=>{
            const result = await _store_store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch(opts.initiator.initiate({
                ...opts.arg,
                limit: _data_Constants__WEBPACK_IMPORTED_MODULE_2__/* .ITEM_PER_PAGE */ .BJ,
                offset: noOffset ? 0 : updatedOffset
            }));
            const { data: resData  } = result;
            if (resData && resData.length > 0) {
                setData((prevData)=>[
                        ...prevData,
                        ...resData
                    ]);
                setOffset(updatedOffset);
                if (resData.length < _data_Constants__WEBPACK_IMPORTED_MODULE_2__/* .ITEM_PER_PAGE */ .BJ) setHasMore(false);
                else setHasMore(true);
                if (resData.length === 0) setHasMore(false);
            } else {
                setHasMore(false);
            }
            setLoading(false);
        };
        setLoading(true);
        setTimeout(fetchNewWikis, _data_Constants__WEBPACK_IMPORTED_MODULE_2__/* .FETCH_DELAY_TIME */ .Nf);
    };
    return {
        fetcher,
        hasMore,
        setHasMore,
        setLoading,
        data,
        setData,
        loading,
        offset,
        setOffset
    };
};


/***/ }),

/***/ "./src/hooks/useTranslatedTimestamps.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useTranslatedTimestamps; }
/* harmony export */ });
/* harmony import */ var _utils_DataTransform_getFormattedDate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/DataTransform/getFormattedDate.ts");
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/next-i18next/dist/esm/index.js");


const useTranslatedTimestamps = (activity, locale, timeStamp)=>{
    const isCreated = activity === "New";
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)("common");
    const readAbleTimeStamp = (0,_utils_DataTransform_getFormattedDate__WEBPACK_IMPORTED_MODULE_1__/* .getReadableDate */ ._)(timeStamp);
    const handleEditedCase = (unit, duration)=>{
        if (unit.includes("second")) return "".concat(duration).concat(t("editedSecs"));
        if (unit.includes("minute")) return "".concat(duration).concat(t("editedMins"));
        if (unit.includes("hour")) return "".concat(duration).concat(t("editedHours"));
        if (unit.includes("day")) return "".concat(duration).concat(t("editedDays"));
        if (unit.includes("month")) return "".concat(duration).concat(t("editedMonths"));
        if (unit.includes("year")) return "".concat(duration).concat(t("editedYears"));
    };
    const handleCreatedCase = (unit, duration)=>{
        if (unit.includes("second")) return "".concat(duration).concat(t("createdSecs"));
        if (unit.includes("minute")) return "".concat(duration).concat(t("createdMins"));
        if (unit.includes("hour")) return "".concat(duration).concat(t("createdHours"));
        if (unit.includes("day")) return "".concat(duration).concat(t("createdDays"));
        if (unit.includes("month")) return "".concat(duration).concat(t("createdMonths"));
        if (unit.includes("year")) return "".concat(duration).concat(t("createdYears"));
    };
    const handleActivity = (unit, duration, activity)=>{
        switch(activity){
            case "New":
                return handleCreatedCase(unit, duration);
            case "Edited":
                return handleEditedCase(unit, duration);
            default:
                return "";
        }
    };
    const handleLocale = ()=>{
        switch(locale){
            case "en":
                return "".concat(t(isCreated ? "Created" : "Edited"), " ").concat(readAbleTimeStamp, " ").concat(t("ago"));
            default:
                const timeStampRegex = /(\d)\s(\w+)/;
                const match = readAbleTimeStamp.match(timeStampRegex);
                if (!match) return;
                const [_, duration, unit] = match;
                return handleActivity(unit, duration, activity);
        }
    };
    return handleLocale();
};


/***/ }),

/***/ "./src/pages/account/[profile].tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _profile_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("./node_modules/react/jsx-runtime.js");
// EXTERNAL MODULE: ./src/components/Elements/Image/Image.tsx
var Image = __webpack_require__("./src/components/Elements/Image/Image.tsx");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/tabs/dist/index.esm.js
var index_esm = __webpack_require__("./node_modules/@chakra-ui/tabs/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/icon/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("./node_modules/react/index.js");
// EXTERNAL MODULE: ./node_modules/react-icons/ti/index.esm.js
var ti_index_esm = __webpack_require__("./node_modules/react-icons/ti/index.esm.js");
// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var ri_index_esm = __webpack_require__("./node_modules/react-icons/ri/index.esm.js");
// EXTERNAL MODULE: ./src/components/Profile/CustomTab.tsx
var CustomTab = __webpack_require__("./src/components/Profile/CustomTab.tsx");
// EXTERNAL MODULE: ./node_modules/react-infinite-scroll-hook/dist/react-infinite-scroll-hook.esm.js + 1 modules
var react_infinite_scroll_hook_esm = __webpack_require__("./node_modules/react-infinite-scroll-hook/dist/react-infinite-scroll-hook.esm.js");
// EXTERNAL MODULE: ./src/services/wikis/index.ts
var services_wikis = __webpack_require__("./src/services/wikis/index.ts");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var layout_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/spinner/dist/index.esm.js
var spinner_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/spinner/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__("./node_modules/next/router.js");
;// CONCATENATED MODULE: ./src/components/Elements/icons/ProfileEmptyState.tsx



const ProfileEmptyState = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Icon */.JO, {
        width: "504",
        height: "290",
        viewBox: "0 0 509 300",
        fill: "none",
        sx: {
            ".rect-1": {
                fill: "#F7FAFC"
            },
            ".rect-2": {
                fill: "white"
            },
            ".rect-3": {
                fill: "#E6E6E6",
                stroke: "#E6E6E6"
            },
            ".rect-5": {
                stroke: "#CBD5E0"
            },
            _dark: {
                ".rect-1": {
                    fill: "white",
                    fillOpacity: "0.04"
                },
                ".rect-2": {
                    fill: "#2D3748"
                },
                ".rect-3": {
                    fill: "#718096",
                    stroke: "#718096"
                },
                ".rect-5": {
                    stroke: "white",
                    strokeOpacity: "0.16",
                    strokeWidth: "0.528579"
                }
            }
        },
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m489 138.26h-437c-11.046 0-20 8.954-20 20v69.479c0 11.046 8.9543 20 20 20h437c11.046 0 20-8.954 20-20v-69.479c0-11.046-8.954-20-20-20z",
                className: "rect-1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m184.42 17.709-165.4 90.945c-7.7433 4.258-10.527 13.963-6.2186 21.678l81.567 146.04c4.3088 7.714 14.079 10.517 21.822 6.26l165.4-90.945c7.743-4.258 10.527-13.963 6.219-21.678l-81.567-146.04c-4.309-7.7149-14.079-10.518-21.822-6.26z",
                className: "rect-2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m145.05 167.17-73.608 40.472c-2.6617 1.464-3.6188 4.8-2.1376 7.452 1.4811 2.652 4.8396 3.615 7.5014 2.152l73.607-40.472c2.662-1.464 3.619-4.8 2.138-7.452s-4.84-3.616-7.501-2.152z",
                className: "rect-3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m242.14 140.03-161.23 88.654c-1.6939 0.931-2.3029 3.054-1.3603 4.742 0.9425 1.687 3.0797 2.3 4.7736 1.369l161.23-88.653c1.694-0.931 2.303-3.055 1.36-4.742-0.943-1.688-3.08-2.301-4.774-1.37z",
                className: "rect-3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m247.5 149.64-161.23 88.654c-1.6939 0.931-2.3029 3.054-1.3603 4.742 0.9425 1.687 3.0797 2.3 4.7736 1.369l161.23-88.653c1.694-0.931 2.303-3.055 1.36-4.742-0.942-1.688-3.079-2.301-4.773-1.37z",
                className: "rect-3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m252.38 158.36-161.23 88.654c-1.6939 0.931-2.3029 3.054-1.3603 4.742 0.9425 1.687 3.0797 2.3 4.7736 1.369l161.23-88.653c1.694-0.931 2.303-3.055 1.36-4.742-0.942-1.688-3.079-2.301-4.773-1.37z",
                className: "rect-3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m170.66 228.4-69.225 38.064c-1.4523 0.798-1.9744 2.618-1.166 4.064 0.807 1.447 2.639 1.972 4.091 1.174l69.226-38.063c1.452-0.798 1.974-2.618 1.166-4.065-0.808-1.446-2.64-1.972-4.092-1.174z",
                className: "rect-3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m184.55 17.939-165.4 90.945c-7.6154 4.187-10.354 13.732-6.1159 21.32l81.567 146.04c4.2377 7.588 13.846 10.344 21.462 6.157l165.4-90.945c7.615-4.187 10.353-13.732 6.115-21.32l-81.566-146.04c-4.238-7.5874-13.847-10.344-21.462-6.1566z",
                className: "rect-5",
                strokeWidth: ".52858"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m487.53 95.258-184.12-17.999c-9.617-0.9401-18.187 6.0928-19.142 15.708l-16.704 168.22c-0.954 9.616 6.068 18.173 15.685 19.113l184.12 17.999c9.617 0.94 18.187-6.093 19.142-15.708l16.704-168.22c0.954-9.616-6.068-18.173-15.685-19.113z",
                className: "rect-2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m373.77 198.68-84.597-8.27c-3.023-0.295-5.717 1.915-6.017 4.938-0.301 3.023 1.907 5.713 4.93 6.008l84.597 8.27c3.023 0.296 5.717-1.915 6.017-4.938s-1.907-5.713-4.93-6.008z",
                className: "rect-3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m471.42 232.34-186.11-18.194c-2.199-0.215-4.158 1.393-4.376 3.591-0.219 2.199 1.387 4.155 3.586 4.37l186.11 18.194c2.199 0.214 4.158-1.393 4.377-3.592 0.218-2.198-1.387-4.154-3.586-4.369z",
                className: "rect-3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m470.33 243.29-186.11-18.194c-2.199-0.215-4.158 1.393-4.376 3.591-0.219 2.199 1.387 4.155 3.586 4.37l186.11 18.194c2.199 0.214 4.158-1.393 4.377-3.592 0.218-2.198-1.387-4.154-3.586-4.369z",
                className: "rect-3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m469.24 254.23-186.11-18.194c-2.199-0.215-4.158 1.393-4.376 3.591-0.219 2.199 1.387 4.155 3.586 4.37l186.11 18.194c2.199 0.214 4.158-1.393 4.377-3.592 0.218-2.198-1.387-4.154-3.586-4.369z",
                className: "rect-3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m359.09 265.57-78.626-7.686c-1.923-0.189-3.638 1.218-3.829 3.142-0.191 1.923 1.214 3.635 3.138 3.823l78.625 7.686c1.924 0.188 3.638-1.219 3.829-3.142 0.191-1.924-1.214-3.635-3.137-3.823z",
                className: "rect-3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m487.51 95.526-184.12-17.999c-9.47-0.9256-17.908 5.9991-18.848 15.467l-16.704 168.22c-0.94 9.468 5.974 17.893 15.443 18.819l184.12 17.999c9.47 0.925 17.908-6 18.848-15.467l16.704-168.22c0.94-9.467-5.974-17.893-15.444-18.818z",
                strokeWidth: ".53819",
                className: "rect-5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m10.162 125.6c-5.3993-9.636-1.9646-21.825 7.6716-27.224l157.57-88.289c9.636-5.3992 21.825-1.9646 27.224 7.6716l41.541 74.138-192.47 107.84-41.541-74.138z",
                className: "rect-3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m284.75 93.198c0.989-9.8918 9.811-17.108 19.702-16.119l183.87 18.395c8.792 0.8797 15.207 8.7207 14.327 17.514l-8.642 86.384-217.7-21.78 8.443-84.394z",
                className: "rect-3"
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Elements/index.ts + 11 modules
var Elements = __webpack_require__("./src/components/Elements/index.ts");
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 23 modules
var esm = __webpack_require__("./node_modules/next-i18next/dist/esm/index.js");
;// CONCATENATED MODULE: ./src/components/Profile/EmptyState.tsx






const EmptyState = (param)=>{
    let { title , body  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)("account");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Flex */.kC, {
        flexDir: "column",
        textAlign: "center",
        align: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileEmptyState, {
                maxBlockSize: "40vw"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                fontWeight: "bold",
                fontSize: "3xl",
                mt: "8",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                color: "fadedText2",
                children: body
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* LinkButton */.Qj, {
                href: "/create-wiki",
                px: "16",
                w: "fit-content",
                mt: "16",
                children: t("createWikiBtn")
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/hooks/useInfiniteData.ts
var useInfiniteData = __webpack_require__("./src/hooks/useInfiniteData.ts");
// EXTERNAL MODULE: ./src/components/Wiki/WikiPreviewCard/WikiPreviewCard.tsx + 1 modules
var WikiPreviewCard = __webpack_require__("./src/components/Wiki/WikiPreviewCard/WikiPreviewCard.tsx");
;// CONCATENATED MODULE: ./src/components/Profile/Collected.tsx




const Collected = (param)=>{
    let { wikis  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* SimpleGrid */.MI, {
        maxW: "1200px",
        w: "100%",
        mx: "auto",
        columns: {
            base: 1,
            md: 2,
            lg: 3
        },
        spacingX: 3,
        spacingY: 12,
        children: wikis.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(WikiPreviewCard/* default */.Z, {
                lastUpdated: item.datetime,
                wiki: item.content[0]
            }, i))
    });
};
/* harmony default export */ var Profile_Collected = (Collected);

// EXTERNAL MODULE: ./src/data/Constants.ts
var Constants = __webpack_require__("./src/data/Constants.ts");
;// CONCATENATED MODULE: ./src/components/Profile/UserWikis/UserCreatedWikis.tsx











const UserCreatedWikis = (param)=>{
    let { createdWikis  } = param;
    const router = (0,next_router.useRouter)();
    const address = router.query.profile;
    const { t  } = (0,esm/* useTranslation */.$G)("account");
    const { data: wikis , fetcher: fetchMoreWikis , loading , hasMore  } = (0,useInfiniteData/* useInfiniteData */.c)({
        initiator: services_wikis/* getUserCreatedWikis */.OS,
        arg: {
            id: address
        }
    }, createdWikis);
    const [createdWikisSentryRef] = (0,react_infinite_scroll_hook_esm/* default */.Z)({
        loading,
        hasNextPage: hasMore,
        onLoadMore: ()=>fetchMoreWikis()
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
        py: "10",
        px: {
            base: 6,
            lg: 0
        },
        children: [
            wikis.length < 1 && !hasMore && /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Center */.M5, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState, {
                    title: t("CreateEmptyStateTitle"),
                    body: t("createEmptyStateDescription")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Profile_Collected, {
                wikis: wikis
            }),
            (loading || hasMore) && wikis.length >= Constants/* ITEM_PER_PAGE */.BJ ? /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Center */.M5, {
                mt: 8,
                ref: createdWikisSentryRef,
                w: "full",
                h: "16",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner_dist_index_esm/* Spinner */.$, {
                    size: "xl"
                })
            }) : !(wikis.length < 1 && !hasMore) && /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Center */.M5, {
                mt: "10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                    fontWeight: "semibold",
                    children: t("seenItAll")
                })
            })
        ]
    });
};
/* harmony default export */ var UserWikis_UserCreatedWikis = (UserCreatedWikis);

;// CONCATENATED MODULE: ./src/components/Profile/UserWikis/UserEditedWikis.tsx











const UserEditedWikis = (param)=>{
    let { editedWikis  } = param;
    const router = (0,next_router.useRouter)();
    const address = router.query.profile;
    const { t  } = (0,esm/* useTranslation */.$G)("account");
    const { data: wikis , fetcher: fetchMoreWikis , loading , hasMore  } = (0,useInfiniteData/* useInfiniteData */.c)({
        initiator: services_wikis/* getUserEditedWikis */.Or,
        arg: {
            id: address
        }
    }, editedWikis);
    const [editedWikisSentryRef] = (0,react_infinite_scroll_hook_esm/* default */.Z)({
        loading,
        hasNextPage: hasMore,
        onLoadMore: ()=>fetchMoreWikis()
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
        py: "10",
        px: {
            base: 6,
            lg: 0
        },
        children: [
            wikis.length < 1 && !hasMore && /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Center */.M5, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState, {
                    title: t("editEmptyStateTitle"),
                    body: t("editEmptyStateDescription")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Profile_Collected, {
                wikis: wikis
            }),
            (loading || hasMore) && wikis.length >= Constants/* ITEM_PER_PAGE */.BJ ? /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Center */.M5, {
                mt: 8,
                ref: editedWikisSentryRef,
                w: "full",
                h: "16",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner_dist_index_esm/* Spinner */.$, {
                    size: "xl"
                })
            }) : !(wikis.length < 1 && !hasMore) && /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Center */.M5, {
                mt: "10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                    fontWeight: "semibold",
                    children: t("seenItAll")
                })
            })
        ]
    });
};
/* harmony default export */ var UserWikis_UserEditedWikis = (UserEditedWikis);

;// CONCATENATED MODULE: ./src/components/Profile/Collections.tsx









const Collections = (param)=>{
    let { createdWikis , editedWikis  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)("account");
    const SECTIONS = [
        {
            labelKey: "wikis",
            icon: ti_index_esm/* TiDocumentAdd */.bBL,
            Component: ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(UserWikis_UserCreatedWikis, {
                    createdWikis: createdWikis
                })
        },
        {
            labelKey: "edits",
            icon: ri_index_esm/* RiEdit2Line */.enh,
            Component: ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(UserWikis_UserEditedWikis, {
                    editedWikis: editedWikis
                })
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Tabs */.mQ, {
        alignSelf: "self-start",
        w: "full",
        mt: "6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* TabList */.td, {
                pl: 5,
                children: SECTIONS.map((section, sid)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomTab/* CustomTab */.o, {
                        _selected: {
                            color: "brandLinkColor !important",
                            _after: {
                                background: "brandLinkColor !important"
                            }
                        },
                        fontWeight: "semibold",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
                                fontSize: "2xl",
                                as: section.icon,
                                mr: "3"
                            }),
                            t(section.labelKey)
                        ]
                    }, sid))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* TabPanels */.nP, {
                children: SECTIONS.map((section, sid)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* TabPanel */.x4, {
                        p: {
                            md: "8",
                            xl: 0
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(section.Component, {})
                    }, sid))
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Profile/SidebarFilter/constants.ts
const FILTER_SIDEBAR_SIZE = {
    OPEN: 85,
    CLOSE: 15
};
const COLLECTIONS_DISPLAY_SIZES = {
    LARGE: "390px",
    SMALL: "257px"
};
const STATUS_FILTERS = {
    BUY_NOW: "Buy Now",
    ON_AUCTION: "On Auction",
    NEW: "New",
    HAS_OFFERS: "Has Offers"
};
const CURRENCIES = {
    DOLLAR: "United States Dollar (USD)",
    ETHER: "Ether (ETH)"
};

// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-utils/dist/chakra-ui-react-utils.esm.js
var chakra_ui_react_utils_esm = __webpack_require__("./node_modules/@chakra-ui/react-utils/dist/chakra-ui-react-utils.esm.js");
;// CONCATENATED MODULE: ./src/components/Profile/utils.ts


const useStickyElement = ()=>{
    const [elementIsSticky, setElementIsStiky] = (0,react.useState)(false);
    const stickyRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        const onScroll = ()=>{
            var ref;
            if (!(stickyRef === null || stickyRef === void 0 ? void 0 : stickyRef.current)) return;
            const headerIsSticky = window.pageYOffset > (stickyRef === null || stickyRef === void 0 ? void 0 : (ref = stickyRef.current) === null || ref === void 0 ? void 0 : ref.offsetTop);
            setElementIsStiky(headerIsSticky);
        };
        window.addEventListener("scroll", onScroll, {
            passive: true
        });
        // clean up code
        return ()=>window.removeEventListener("scroll", onScroll);
    }, [
        elementIsSticky
    ]);
    return [
        stickyRef,
        elementIsSticky
    ];
};
const [ProfileProvider, useProfileContext] = (0,chakra_ui_react_utils_esm/* createContext */.kr)({
    name: "ProfilePage"
});

// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/node_modules/@chakra-ui/hooks/dist/index.esm.js + 3 modules
var hooks_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/react/node_modules/@chakra-ui/hooks/dist/index.esm.js");
;// CONCATENATED MODULE: ./src/components/Profile/useProfile.ts




const useProfile = ()=>{
    const [headerRef, headerIsSticky] = useStickyElement();
    const [filterSidebarRef, filterSidebarIsSticky] = useStickyElement();
    const keepHeaderSticky = headerIsSticky && !filterSidebarIsSticky;
    const [filterSidebarIsOpen, filterSidebarSwitch] = (0,hooks_dist_index_esm/* useBoolean */.kt)(false);
    const filterSidebarSize = filterSidebarIsOpen ? FILTER_SIDEBAR_SIZE.OPEN : FILTER_SIDEBAR_SIZE.CLOSE;
    const [displaySize, setDisplaySize] = (0,react.useState)(COLLECTIONS_DISPLAY_SIZES.LARGE);
    return {
        headerRef,
        headerIsSticky: keepHeaderSticky,
        filterSidebarRef,
        filterSidebarIsSticky,
        filterSidebarIsOpen,
        filterSidebarSwitch,
        filterSidebarSize,
        displaySize,
        setDisplaySize
    };
};

// EXTERNAL MODULE: ./node_modules/@chakra-ui/toast/dist/index.esm.js + 1 modules
var toast_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/toast/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/index.esm.js + 6 modules
var system_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/system/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/skeleton/dist/index.esm.js + 1 modules
var skeleton_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/skeleton/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/button/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/tooltip/dist/index.esm.js
var tooltip_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/tooltip/dist/index.esm.js");
// EXTERNAL MODULE: ./src/components/Elements/Avatar/DisplayAvatar.tsx
var DisplayAvatar = __webpack_require__("./src/components/Elements/Avatar/DisplayAvatar.tsx");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/chakra-ui-icons.esm.js + 1 modules
var chakra_ui_icons_esm = __webpack_require__("./node_modules/@chakra-ui/icons/dist/chakra-ui-icons.esm.js");
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var fa_index_esm = __webpack_require__("./node_modules/react-icons/fa/index.esm.js");
;// CONCATENATED MODULE: ./src/components/Profile/LoadingProfile.tsx






const LoadingProfile = (props)=>{
    const { hide  } = props;
    const { headerIsSticky  } = useProfileContext();
    const isSticky = headerIsSticky && hide;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Flex */.kC, {
                align: "center",
                justify: "space-between",
                w: "full",
                px: "6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(system_dist_index_esm/* chakra.span */.m$.span, {
                        flex: "1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Flex */.kC, {
                        direction: isSticky ? "row" : "column",
                        align: "center",
                        gap: "3",
                        flex: "1",
                        justifyContent: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* SkeletonCircle */.s7, {
                                mt: "-64px",
                                boxSize: "32",
                                borderWidth: 2,
                                borderColor: "white",
                                justifySelf: "center",
                                ...isSticky && {
                                    mt: 0,
                                    boxSize: 12
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(system_dist_index_esm/* chakra.span */.m$.span, {
                                    fontSize: isSticky ? "2xl" : "3xl",
                                    fontWeight: "semibold",
                                    letterSpacing: "tighter",
                                    children: "Unnamed"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(system_dist_index_esm/* chakra.span */.m$.span, {
                        display: "flex",
                        flex: "1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(button_dist_index_esm/* ButtonGroup */.hE, {
                            isAttached: true,
                            variant: "outline",
                            ml: "auto",
                            my: "6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* IconButton */.hU, {
                                    mr: "-px",
                                    boxSize: "12",
                                    "aria-label": "Share",
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaShareAlt */.PPi, {}),
                                    rounded: "xl",
                                    _hover: {
                                        shadow: "xl"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* IconButton */.hU, {
                                    boxSize: "12",
                                    "aria-label": "Settings",
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icons_esm/* SettingsIcon */.ew, {}),
                                    rounded: "xl",
                                    _hover: {
                                        shadow: "xl"
                                    }
                                })
                            ]
                        })
                    })
                ]
            }),
            !isSticky && /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Flex */.kC, {
                mt: "2",
                gap: "3",
                direction: "column",
                px: "6",
                w: "full",
                align: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Flex */.kC, {
                    align: "center",
                    gap: "2",
                    color: "fadedText2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(system_dist_index_esm/* chakra.span */.m$.span, {
                            fontWeight: "medium",
                            children: "userName"
                        })
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/hooks/useENSData.ts
var useENSData = __webpack_require__("./src/hooks/useENSData.ts");
// EXTERNAL MODULE: ./src/utils/textUtils.ts
var textUtils = __webpack_require__("./src/utils/textUtils.ts");
// EXTERNAL MODULE: ./src/services/profile/utils.ts
var utils = __webpack_require__("./src/services/profile/utils.ts");
// EXTERNAL MODULE: ./src/store/hook.ts
var hook = __webpack_require__("./src/store/hook.ts");
// EXTERNAL MODULE: ./src/store/store.ts + 9 modules
var store = __webpack_require__("./src/store/store.ts");
// EXTERNAL MODULE: ./src/services/editor/index.ts + 1 modules
var editor = __webpack_require__("./src/services/editor/index.ts");
// EXTERNAL MODULE: ./src/store/slices/leaderboard.ts
var slices_leaderboard = __webpack_require__("./src/store/slices/leaderboard.ts");
;// CONCATENATED MODULE: ./src/utils/DataTransform/leaderboard.utils.ts
const sortLeaderboards = (editors)=>{
    if (editors) {
        const arrayForSort = [
            ...editors
        ];
        const sortedleaderboards = arrayForSort.sort((firstEditor, nextEditor)=>{
            return nextEditor.totalRewards - firstEditor.totalRewards;
        });
        return sortedleaderboards;
    }
    return null;
};
const getEditorRank = (address, leaderboard)=>{
    return leaderboard.findIndex((editor)=>editor.id === address);
};

// EXTERNAL MODULE: ./src/components/Icons/lensterIcon.tsx
var lensterIcon = __webpack_require__("./src/components/Icons/lensterIcon.tsx");
;// CONCATENATED MODULE: ./src/data/UserSocialLinksData.ts


const UserSocialLinksData = {
    twitter: {
        label: "Twitter",
        icon: ri_index_esm/* RiTwitterLine */.HSY,
        urlPrefix: (username)=>{
            if (username === null || username === void 0 ? void 0 : username.startsWith("https://twitter.com")) return username;
            return "https://twitter.com/".concat(username);
        }
    },
    website: {
        label: "Website",
        icon: ri_index_esm/* RiLink */._q$,
        urlPrefix: (website)=>website
    },
    instagram: {
        label: "Instagram",
        icon: ri_index_esm/* RiInstagramLine */.Adh,
        urlPrefix: (username)=>{
            if (username === null || username === void 0 ? void 0 : username.startsWith("https://instagram.com")) return username;
            return "https://instagram.com/".concat(username);
        }
    },
    lens: {
        label: "Lenster",
        icon: lensterIcon/* default */.Z,
        urlPrefix: (username)=>{
            if (username === null || username === void 0 ? void 0 : username.startsWith("https://lenster.xyz")) return username;
            return "https://lenster.xyz/u/".concat(username);
        }
    }
};

;// CONCATENATED MODULE: ./src/components/Icons/etherscan.tsx



const EtherscanIcon = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Icon */.JO, {
        viewBox: "0 0 24 24",
        fill: "currentcolor",
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.48574 11.4269C5.48571 11.2928 5.51217 11.1601 5.56359 11.0363C5.61501 10.9126 5.69038 10.8002 5.78536 10.7056C5.88035 10.611 5.99308 10.5362 6.11708 10.4853C6.24108 10.4345 6.37391 10.4086 6.50794 10.4092L8.20265 10.4148C8.47287 10.4148 8.73202 10.5221 8.92309 10.7132C9.11416 10.9043 9.22151 11.1634 9.22151 11.4336V17.8419C9.41241 17.7854 9.65726 17.7251 9.92548 17.6622C10.1117 17.6183 10.2777 17.5129 10.3965 17.3629C10.5153 17.2129 10.58 17.0272 10.58 16.8359V8.88695C10.58 8.75313 10.6063 8.62062 10.6575 8.49698C10.7087 8.37335 10.7838 8.261 10.8784 8.16637C10.973 8.07174 11.0854 7.99667 11.209 7.94545C11.3326 7.89423 11.4651 7.86786 11.5989 7.86785H13.297C13.5672 7.86789 13.8263 7.97525 14.0174 8.16631C14.2085 8.35738 14.3158 8.6165 14.3159 8.88671V16.2647C14.3159 16.2647 14.7408 16.0926 15.1551 15.9178C15.3089 15.8527 15.4402 15.7438 15.5325 15.6046C15.6248 15.4654 15.6741 15.3021 15.6743 15.1351V6.33936C15.6743 6.20557 15.7006 6.07308 15.7518 5.94947C15.803 5.82586 15.878 5.71354 15.9726 5.61893C16.0672 5.52432 16.1796 5.44927 16.3032 5.39807C16.4268 5.34686 16.5593 5.32051 16.6931 5.32051H18.3911C18.6613 5.32051 18.9205 5.42785 19.1116 5.61892C19.3027 5.80999 19.41 6.06914 19.4101 6.33936V13.5822C20.8822 12.5153 22.3743 11.2319 23.5583 9.68891C23.7301 9.46493 23.8437 9.20191 23.8892 8.92331C23.9346 8.64472 23.9103 8.35921 23.8186 8.09226C23.0174 5.75751 21.5147 3.72718 19.5159 2.27891C17.517 0.83063 15.1196 0.0350992 12.6515 0.0010879C5.99594 -0.0883183 0.495498 5.34462 0.496151 12.001C0.489616 14.1073 1.03935 16.1779 2.08977 18.0036C2.23463 18.2533 2.44775 18.4565 2.70408 18.5893C2.96041 18.7221 3.24932 18.779 3.53686 18.7533C3.85812 18.725 4.25808 18.685 4.73355 18.6292C4.9405 18.6056 5.13156 18.5068 5.27034 18.3515C5.40913 18.1962 5.48593 17.9952 5.48614 17.787V11.4269",
                fill: "#1A202C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.4493 21.704C7.23922 23.0061 9.35445 23.7877 11.561 23.9622C13.7675 24.1368 15.9794 23.6976 17.9518 22.6932C19.9242 21.6887 21.5803 20.1582 22.7369 18.271C23.8935 16.3838 24.5054 14.2134 24.5051 12C24.5051 11.7236 24.4922 11.4504 24.4738 11.1787C20.0899 17.7166 11.9956 20.7731 5.44922 21.7042",
                fill: "#718096"
            })
        ]
    });
};
/* harmony default export */ var etherscan = (EtherscanIcon);

;// CONCATENATED MODULE: ./src/components/Profile/UserSocialLinks.tsx





const UserSocialLinks = (param)=>{
    let { links , address  } = param;
    const socialsWithURl = Object.entries(links || {}).filter((e)=>Boolean(e[1]));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Flex */.kC, {
        justify: "center",
        align: "center",
        gap: 4,
        children: [
            links && socialsWithURl.map((social, index)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Link */.rU, {
                    position: "relative",
                    height: "25px",
                    isExternal: true,
                    rel: "noopener nofollow",
                    href: UserSocialLinksData[social[0]].urlPrefix(social[1] || ""),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_dist_index_esm/* Tooltip */.u, {
                        hasArrow: true,
                        label: UserSocialLinksData[social[0]].label,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
                                "aria-label": UserSocialLinksData[social[0]].label,
                                as: UserSocialLinksData[social[0]].icon,
                                boxSize: "25px",
                                _hover: {
                                    opacity: 0.7
                                }
                            })
                        })
                    })
                }, index);
            }),
            address && /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Link */.rU, {
                position: "relative",
                isExternal: true,
                rel: "noopener nofollow",
                href: "https://etherscan.io/address/".concat(address),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_dist_index_esm/* Tooltip */.u, {
                    hasArrow: true,
                    label: "etherscan",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
                            "aria-label": "etherscan",
                            as: etherscan,
                            boxSize: "22px",
                            _dark: {
                                filter: "invert(100%) hue-rotate(180deg)"
                            },
                            _hover: {
                                opacity: 0.7
                            }
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Profile_UserSocialLinks = (UserSocialLinks);

// EXTERNAL MODULE: ./src/components/Elements/EditorRank/EditorRank.tsx
var EditorRank = __webpack_require__("./src/components/Elements/EditorRank/EditorRank.tsx");
// EXTERNAL MODULE: ./src/env.mjs
var env = __webpack_require__("./src/env.mjs");
// EXTERNAL MODULE: ./src/hooks/useAddress.ts
var useAddress = __webpack_require__("./src/hooks/useAddress.ts");
;// CONCATENATED MODULE: ./src/components/Profile/UserDetails.tsx





















const UserDetails = (param)=>{
    let { hide  } = param;
    const router = (0,next_router.useRouter)();
    const { address: userAddress  } = (0,useAddress/* useAddress */.S)();
    const address = router.query.profile;
    const { profileData  } = (0,utils/* useUserProfileData */.Cf)(utils/* UserProfileFetchOptions.USER_PROFILE */.Ky.USER_PROFILE, address);
    const { headerIsSticky  } = useProfileContext();
    const [, ensUserName, loading] = (0,useENSData/* useENSData */.L)(address);
    const isSticky = headerIsSticky && hide;
    const customLink = "".concat(env/* env.NEXT_PUBLIC_DOMAIN */.O.NEXT_PUBLIC_DOMAIN, "/account/").concat((profileData === null || profileData === void 0 ? void 0 : profileData.username) || address || ensUserName);
    const clipboard = (0,hooks_dist_index_esm/* useClipboard */.VP)(customLink || "");
    const toast = (0,toast_dist_index_esm/* useToast */.pm)();
    const { addressRank , leaderboard  } = (0,hook/* useAppSelector */.C)((state)=>state.leaderboard);
    const dispatch = (0,hook/* useAppDispatch */.T)();
    const isFetched = (0,react.useRef)(false);
    const tooltipProps = {
        placement: "top",
        hasArrow: true,
        rounded: "md",
        fontWeight: "semibold",
        fontSize: "md",
        px: 3,
        py: 2
    };
    const { t  } = (0,esm/* useTranslation */.$G)("account");
    // TODO: change
    (0,react.useEffect)(()=>{
        if (leaderboard.length < 1 && !isFetched.current) {
            const fetchLeaderboard = async ()=>{
                const result = await store/* store.dispatch */.h.dispatch(editor/* getLeaderboard.initiate */.Zp.initiate());
                if (result.data) {
                    const sortedleaderboards = sortLeaderboards(result.data);
                    dispatch((0,slices_leaderboard/* setLeaderboards */.IA)(sortedleaderboards));
                    isFetched.current = true;
                }
            };
            fetchLeaderboard();
        } else {
            dispatch((0,slices_leaderboard/* setAddressRank */.dY)(getEditorRank(address, leaderboard)));
        }
    }, [
        leaderboard,
        address,
        dispatch
    ]);
    if (loading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingProfile, {
        hide: hide
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Flex */.kC, {
        flexDir: {
            base: isSticky ? "row" : "column",
            sm: "row"
        },
        align: "center",
        justify: "space-between",
        w: "full",
        px: {
            base: "0",
            sm: "6"
        },
        gap: 3,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(system_dist_index_esm/* chakra.span */.m$.span, {
                flex: "1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Flex */.kC, {
                direction: isSticky ? "row" : "column",
                align: "center",
                gap: "3",
                flex: "1",
                justifyContent: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                        mt: "".concat(isSticky ? 0 : "-11"),
                        zIndex: "docked",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayAvatar/* default */.Z, {
                            alt: profileData === null || profileData === void 0 ? void 0 : profileData.username,
                            size: isSticky ? 35 : 130,
                            overflow: "hidden",
                            borderWidth: 2,
                            borderColor: "white",
                            rounded: "full",
                            justifySelf: "center",
                            ...isSticky && {
                                mt: 0,
                                boxSize: 9
                            },
                            address: address,
                            avatarIPFS: profileData === null || profileData === void 0 ? void 0 : profileData.avatar,
                            wrapperProps: {
                                zIndex: "calc(var(--chakra-zIndices-sticky) - 1)"
                            },
                            svgProps: {
                                boxSize: isSticky ? "10" : "32",
                                overflow: "hidden",
                                borderWidth: 2,
                                borderColor: "white",
                                rounded: "full",
                                justifySelf: "center"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                        isLoaded: !loading,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* VStack */.gC, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* HStack */.Ug, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(system_dist_index_esm/* chakra.span */.m$.span, {
                                            fontSize: isSticky ? "lg" : "3xl",
                                            fontWeight: "semibold",
                                            letterSpacing: "tighter",
                                            children: (profileData === null || profileData === void 0 ? void 0 : profileData.username) || ensUserName || (0,textUtils/* shortenAccount */.p0)(address)
                                        }),
                                        addressRank !== null && /*#__PURE__*/ (0,jsx_runtime.jsx)(system_dist_index_esm/* chakra.span */.m$.span, {
                                            mb: "18px !important",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EditorRank/* default */.Z, {
                                                size: "22",
                                                rank: addressRank
                                            })
                                        })
                                    ]
                                }),
                                !isSticky && /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* VStack */.gC, {
                                    spacing: 4,
                                    children: [
                                        profileData && /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                            maxW: "min(400px, 80vw)",
                                            textAlign: "center",
                                            children: profileData.bio
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Profile_UserSocialLinks, {
                                            links: profileData === null || profileData === void 0 ? void 0 : profileData.links[0],
                                            address: address || ""
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(system_dist_index_esm/* chakra.span */.m$.span, {
                display: "flex",
                flex: "1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(button_dist_index_esm/* ButtonGroup */.hE, {
                    isAttached: true,
                    variant: "outline",
                    ml: "auto",
                    my: 4,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_dist_index_esm/* Tooltip */.u, {
                            label: t("shareBtnText"),
                            ...tooltipProps,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* IconButton */.hU, {
                                mr: "-px",
                                boxSize: "12",
                                "aria-label": "Share",
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ri_index_esm/* RiShareFill */.fb8, {
                                    size: isSticky ? "15" : "20"
                                }),
                                rounded: "xl",
                                _hover: {
                                    shadow: "xl"
                                },
                                onClick: ()=>{
                                    clipboard.onCopy();
                                    toast({
                                        title: "Profile Link Copied to Clipboard!",
                                        status: "success",
                                        duration: 1000
                                    });
                                },
                                ...isSticky && {
                                    boxSize: 8,
                                    rounded: "4"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_dist_index_esm/* Tooltip */.u, {
                            label: t("settingBtnText"),
                            ...tooltipProps,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* IconButton */.hU, {
                                cursor: "pointer",
                                boxSize: "12",
                                "aria-label": "Settings",
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ri_index_esm/* RiSettings5Fill */.EmM, {
                                    size: isSticky ? "15" : "20"
                                }),
                                rounded: "xl",
                                _hover: {
                                    shadow: "xl"
                                },
                                onClick: ()=>router.push("/settings/account"),
                                disabled: address !== userAddress,
                                ...isSticky && {
                                    boxSize: 8,
                                    rounded: "4"
                                }
                            })
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Profile/UserInfo.tsx





const UserInfo = ()=>{
    const { headerIsSticky , headerRef  } = useProfileContext();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Flex */.kC, {
                align: "center",
                justify: "space-between",
                flex: "auto",
                w: "full",
                px: "6",
                pos: "fixed",
                top: "70px",
                bg: "white",
                _dark: {
                    bg: "gray.800"
                },
                zIndex: headerIsSticky ? "sticky" : -1,
                borderTopWidth: headerIsSticky ? "1px" : "0px",
                shadow: "md",
                opacity: headerIsSticky ? 1 : 0,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserDetails, {
                    hide: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Flex */.kC, {
                flex: "auto",
                w: "full",
                direction: "column",
                ref: headerRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserDetails, {})
            })
        ]
    });
};
/* harmony default export */ var Profile_UserInfo = (UserInfo);

// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__("./node_modules/next-seo/lib/next-seo.module.js");
;// CONCATENATED MODULE: ./src/components/SEO/UserProfile.tsx





const UserProfileHeader = (param)=>{
    let { username , avatarURL , links , bio  } = param;
    let socials = [];
    if (links) socials = Object.keys(links);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* SocialProfileJsonLd */.Sv, {
                type: "Person",
                name: username,
                url: "".concat(env/* env.NEXT_PUBLIC_DOMAIN */.O.NEXT_PUBLIC_DOMAIN, "/account/").concat(username),
                sameAs: socials.map((key)=>{
                    return UserSocialLinksData[key].urlPrefix((links === null || links === void 0 ? void 0 : links[key]) || "");
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "".concat(username, " \xb7 IQ.wiki"),
                description: "Blockchain wikis created by ".concat(username),
                openGraph: {
                    title: "".concat(username, " \xb7 IQ.wiki"),
                    description: bio || "check out this user on IQ.wiki",
                    url: "".concat(env/* env.NEXT_PUBLIC_DOMAIN */.O.NEXT_PUBLIC_DOMAIN, "/account/").concat(username),
                    type: "profile",
                    profile: {
                        username
                    },
                    images: [
                        {
                            url: avatarURL,
                            width: 650,
                            height: 650,
                            alt: "Profile Photo"
                        }
                    ]
                }
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/config/index.ts
var config = __webpack_require__("./src/config/index.ts");
// EXTERNAL MODULE: ./src/data/AvatarData.ts
var AvatarData = __webpack_require__("./src/data/AvatarData.ts");
;// CONCATENATED MODULE: ./src/pages/account/[profile].tsx













const Profile = (param)=>{
    let { profileData , createdWikis , editedWikis  } = param;
    var ref;
    const router = (0,next_router.useRouter)();
    const address = router.query.profile;
    const [avatar] = (0,useENSData/* useENSData */.L)(address);
    const profileContext = useProfile();
    let userAvatar = "";
    if (profileData === null || profileData === void 0 ? void 0 : profileData.avatar) {
        userAvatar = "".concat(config/* default.pinataBaseUrl */.Z.pinataBaseUrl).concat(profileData === null || profileData === void 0 ? void 0 : profileData.avatar);
    } else if (avatar) {
        userAvatar = avatar;
    } else {
        userAvatar = "https://source.boringavatars.com/pixel/".concat(address, "?square=true?colors=").concat(AvatarData/* AvatarColorArray */.M);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserProfileHeader, {
                username: (profileData === null || profileData === void 0 ? void 0 : profileData.username) || address,
                avatarURL: userAvatar,
                links: profileData === null || profileData === void 0 ? void 0 : (ref = profileData.links) === null || ref === void 0 ? void 0 : ref[0],
                bio: profileData === null || profileData === void 0 ? void 0 : profileData.bio
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileProvider, {
                value: profileContext,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Flex */.kC, {
                    mt: -2,
                    direction: "column",
                    align: "center",
                    pos: "relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                            width: "full",
                            height: "56",
                            objectFit: "cover",
                            bgColor: "careersBackground",
                            bgImage: "/images/backgrounds/homepage-bg-white.png",
                            _dark: {
                                bgImage: "/images/backgrounds/careers-background-dark.png"
                            },
                            hideOnError: true,
                            src: "".concat(config/* default.pinataBaseUrl */.Z.pinataBaseUrl).concat(profileData === null || profileData === void 0 ? void 0 : profileData.banner),
                            alt: "".concat((profileData === null || profileData === void 0 ? void 0 : profileData.username) || address, "-background-image")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Profile_UserInfo, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Collections, {
                            createdWikis: createdWikis,
                            editedWikis: editedWikis
                        })
                    ]
                })
            })
        ]
    }, address);
};
Profile.footer = false;
var __N_SSP = true;
/* harmony default export */ var _profile_ = (/*#__PURE__*/react.memo(Profile));


/***/ }),

/***/ "./src/store/hook.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ useAppSelector; },
/* harmony export */   "T": function() { return /* binding */ useAppDispatch; }
/* harmony export */ });
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react-redux/es/index.js");

const useAppDispatch = ()=>(0,react_redux__WEBPACK_IMPORTED_MODULE_0__.useDispatch)();
const useAppSelector = react_redux__WEBPACK_IMPORTED_MODULE_0__.useSelector;


/***/ }),

/***/ "./src/utils/DataTransform/getFormattedDate.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ getReadableDate; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/date-fns/formatDistanceToNowStrict.mjs");

const getReadableDate = (dateToFormat)=>{
    const parsedDate = new Date(dateToFormat);
    if (isNaN(parsedDate.getTime())) {
        return "";
    }
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* .formatDistanceToNowStrict */ .D)(parsedDate, {
        addSuffix: false
    });
};


/***/ }),

/***/ "./src/utils/DataTransform/getUsername.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ getUsername; }
/* harmony export */ });
/* harmony import */ var _textUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/utils/textUtils.ts");

const getUsername = (user, ensDomain)=>{
    var ref;
    if (!user) {
        return "Unknown";
    }
    if ((ref = user.profile) === null || ref === void 0 ? void 0 : ref.username) {
        return user.profile.username;
    }
    if (ensDomain) {
        return ensDomain;
    }
    return user.id ? (0,_textUtils__WEBPACK_IMPORTED_MODULE_0__/* .shortenAccount */ .p0)(user.id) : "Unknown";
};


/***/ }),

/***/ "./src/utils/WikiUtils/getWikiImageUrl.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ getWikiImageUrl; }
/* harmony export */ });
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/config/index.ts");

const getWikiImageUrl = (imageObj)=>{
    var ref;
    return "".concat(_config__WEBPACK_IMPORTED_MODULE_0__/* ["default"].pinataBaseUrl */ .Z.pinataBaseUrl).concat(imageObj ? (ref = imageObj[0]) === null || ref === void 0 ? void 0 : ref.id : "");
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4090,5099,4673,9774,2888,179], function() { return __webpack_exec__("./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Faccount%2F%5Bprofile%5D.tsx&page=%2Faccount%2F%5Bprofile%5D!"); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);